@if (variant() === 'card') {
<om-glass-card class="rounded-[20px] max-w-[680px] mx-auto">
  <ng-container *ngTemplateOutlet="playerContent" />
</om-glass-card>
} @else {
<ng-container *ngTemplateOutlet="playerContent" />
}

<ng-template #playerContent>
  <div
    class="flex items-center gap-3"
    [class]="variant() === 'card' ? 'p-4 md:p-5 gap-4' : 'gap-3'"
  >
    <!-- Play button -->
    <button
      type="button"
      class="shrink-0 rounded-full bg-primary hover:bg-primary-dark flex items-center justify-center transition-colors cursor-pointer active:scale-95 shadow-[0_4px_12px_rgba(224,122,95,0.35)]"
      [class]="variant() === 'card' ? 'w-12 h-12' : 'w-9 h-9'"
      (click)="toggle()"
    >
      <span
        class="material-symbols-outlined text-white"
        [class]="variant() === 'card' ? 'text-[24px]' : 'text-[20px]'"
        >{{ playIcon() }}</span
      >
    </button>

    <!-- Waveform -->
    <div class="flex-1 min-w-0 flex flex-col gap-1">
      @if (label()) {
      <div
        class="text-[10px] font-semibold uppercase tracking-[0.06em] text-primary"
      >
        {{ label() }}
      </div>
      }
      <om-waveform-bars
        [audioUrl]="waveformUrl()"
        [isAnimating]="isPlaying()"
        [heightPx]="variant() === 'card' ? 28 : 24"
        [autoFill]="true"
        [progress]="normalizedProgress()"
        (seekPosition)="onSeek($event)"
      />
    </div>

    <!-- Duration / current time -->
    <div class="text-xs text-slate-400 font-mono shrink-0 tabular-nums">
      @if (isPlaying() || isFinished()) { {{ formattedCurrent() }} } @else { {{
      formattedDuration() }} }
    </div>
  </div>
</ng-template>
